/**
 * Luft till höger på sidor som visar en maskot (från xl, där maskoten visas),
 * så att figuren står i en egen ränna och aldrig ligger över innehåll.
 * Maskoten är 112 px bred och står 24 px från kanten.
 */
export const MASKOT_RANNA = 'xl:pr-[152px]';
